/** Cancel one consumer without cancelling work shared with other selections. */
export const awaitWithAbort = <T>(pending: Promise<T>, signal: AbortSignal): Promise<T> =>
  new Promise((resolve, reject) => {
    const abort = (): void => reject(new DOMException('Aborted', 'AbortError'));
    const finish = (settle: () => void): void => {
      signal.removeEventListener('abort', abort);
      settle();
    };
    pending.then(
      (value) => finish(() => resolve(value)),
      (error: unknown) => finish(() => reject(error))
    );
    if (signal.aborted) abort();
    else signal.addEventListener('abort', abort, { once: true });
  });
